import { __assign } from "tslib";
import { createFakeGetResponder, createFakePostResponder } from '../../test-utils';
// tslint:disable-next-line:max-line-length
import { createInAppNotificationsApi, enableInAppNotificationsUri, inAppNotificationUri } from './index';
import { createHttpTestKit } from '../../http/test-kit';
export var createInAppNotificationApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createInAppNotificationsApi('', fakeHttp);
    var testKit = {
        whenGetInAppNotificationSettings: function () { return createFakeGetResponder(fakeHttp, inAppNotificationUri); },
        whenConfigureInAppNotification: function (dto) { return createFakePostResponder(fakeHttp, enableInAppNotificationsUri)(dto); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map